import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ReactFlagsSelect from "react-flags-select";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  businessCountry: Yup.string().required("Le pays est requis"),
});

function OapiBusinessCountry() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [countrySelected, setCountrySelected] = useState("");
  const cart = useSelector((state) => state.cart);

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      {/* Title Section */}
      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          Dans quel <span style={{ color: "#FF5500" }}>pays</span> se situe
          votre entreprise ?
        </h4>
      </div>

      {/* Form Section */}
      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{
            businessCountry: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            await dispatch(
              addToCart({
                businessCountry: values.businessCountry,
              })
            );
            navigate("/oapi-business-type");
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <ReactFlagsSelect
                  selected={countrySelected}
                  countries={["CM"]}
                  onSelect={(code) => {
                    setFieldValue("businessCountry", code);
                    setCountrySelected(code);
                  }}
                  placeholder="Pays de l'entreprise"
                  searchable
                  searchPlaceholder="Recherchez le pays"
                  className="w-100"
                />
                {errors.businessCountry && touched.businessCountry && (
                  <div
                    className="text-danger"
                    style={{ textAlign: "left", fontSize: "12px" }}
                  >
                    {errors.businessCountry}
                  </div>
                )}
              </div>

              <div className="d-flex justify-content-center mt-2">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default OapiBusinessCountry;
